async function apiNotice(path, { method = 'GET', body, signal } = {}) {
  const token = localStorage.getItem('authToken');
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
  };
  const res = await fetch(`/api/vc-notice${path}`, {
    method,
    headers,
    signal,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const msg = json?.erro?.mensagem || json.message || `Erro ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.codigo = json?.erro?.codigo;
    throw err;
  }
  return json.data;
}

export function listNotices(filtro = 'todos', signal) {
  const qs = filtro && filtro !== 'todos' ? `?filtro=${encodeURIComponent(filtro)}` : '';
  return apiNotice(`/${qs}`, { signal });
}

export function getNotice(id) {
  return apiNotice(`/${id}`);
}

export function createNotice(title) {
  return apiNotice('/', { method: 'POST', body: { title } });
}

export function updateNotice(id, body) {
  return apiNotice(`/${id}`, { method: 'PATCH', body });
}

export function saveNoticeContent(id, html) {
  return apiNotice(`/${id}/conteudo`, { method: 'PUT', body: { html } });
}

export function publishNotice(id, expiresAt, publishAt) {
  return apiNotice(`/${id}/publish`, {
    method: 'POST',
    body: { expiresAt: expiresAt || null, publishAt: publishAt || null },
  });
}

export function scheduleNotice(id, publishAt, expiresAt) {
  return apiNotice(`/${id}/schedule`, { method: 'POST', body: { publishAt, expiresAt } });
}

export function archiveNotice(id) {
  return apiNotice(`/${id}/archive`, { method: 'POST', body: {} });
}

export function deleteNotice(id) {
  return apiNotice(`/${id}`, { method: 'DELETE' });
}

export function presignNoticeImage(id, { mimeType, sizeBytes, fileName }) {
  return apiNotice(`/${id}/imagens/presign`, {
    method: 'POST',
    body: { mimeType, sizeBytes, fileName },
  });
}

export function completeNoticeImage(id, body) {
  return apiNotice(`/${id}/imagens/complete`, { method: 'POST', body });
}

export function deleteNoticeImage(id, guid) {
  return apiNotice(`/${id}/imagens/${encodeURIComponent(guid)}`, { method: 'DELETE' });
}

export function aiWriteNotice({ prompt, draft, history }) {
  return apiNotice('/ai-write', {
    method: 'POST',
    body: { prompt, draft, history },
  });
}

export async function uploadNoticeImage(id, file) {
  if (!file) throw new Error('Arquivo não selecionado.');
  const mimeType = file.type || 'image/jpeg';
  const sizeBytes = file.size;
  const fileName = file.name || 'image.jpg';
  const presign = await presignNoticeImage(id, { mimeType, sizeBytes, fileName });
  const put = await fetch(presign.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': mimeType },
    body: file,
  });
  if (!put.ok) throw new Error('Falha ao enviar a imagem para o armazenamento.');
  return completeNoticeImage(id, {
    key: presign.key,
    guid: presign.guid,
    fileName: presign.fileName || fileName,
    contentType: presign.contentType || mimeType,
    displayWidthPct: 100,
  });
}
